module.exports = __webpack_public_path__ + "static/img/4.310e4708.jpg";